import React from 'react';

export const SearchIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.6715 16.0853L14.1874 12.5996C16.7944 9.11577 16.0835 4.17811 12.5996 1.5711C9.11577 -1.03592 4.17811 -0.325068 1.5711 3.15881C-1.03592 6.64268 -0.325068 11.5803 3.15881 14.1874C5.95734 16.2815 9.80107 16.2815 12.5996 14.1874L16.0853 17.673C16.5233 18.111 17.2335 18.111 17.6715 17.673C18.1095 17.235 18.1095 16.5248 17.6715 16.0868L17.6715 16.0853ZM7.90827 13.5146C4.81197 13.5146 2.30195 11.0046 2.30195 7.90827C2.30195 4.81197 4.81197 2.30195 7.90827 2.30195C11.0046 2.30195 13.5146 4.81197 13.5146 7.90827C13.5113 11.0032 11.0032 13.5113 7.90827 13.5146Z" fill="white"/>
        </svg>
    )
}